module.exports = __webpack_public_path__ + "img/ivorycoast.717ba6f2.svg";